import type { ManagerSettings } from "@forgepoint/shared";
import { BusinessDaysNote } from "./BusinessDaysNote";
import { NumberSettingField } from "./NumberSettingField";

interface ManagerSettingsFormProps {
  value: ManagerSettings;
  onChange: (value: ManagerSettings) => void;
}

/** Settings form for the Manager "Deal Acceleration" template. */
export function ManagerSettingsForm({
  value,
  onChange,
}: ManagerSettingsFormProps) {
  return (
    <div className="space-y-5">
      <BusinessDaysNote />
      <NumberSettingField
        label="Stuck threshold (business days)"
        description="Deals in flight this long are called out as stuck. Anything younger stays out of the report."
        min={1}
        value={value.stuckDays}
        onChange={(stuckDays) => onChange({ ...value, stuckDays })}
      />
      <NumberSettingField
        label="Quote Completed, no reply (business days)"
        description="Completed quotes with no customer reply for this long surface for a nudge."
        min={1}
        value={value.sentNoReplyDays}
        onChange={(sentNoReplyDays) => onChange({ ...value, sentNoReplyDays })}
      />
    </div>
  );
}
